<template>
  <div class="a-wrap">

    <!-- ── ЛОГИН ──────────────────────────────────────────────── -->
    <div v-if="!authed" class="a-login">
      <div class="a-login-box">
        <h1 class="a-logo">MTI Admin</h1>
        <form @submit.prevent="doLogin">
          <input
            v-model="creds.login"
            class="a-input"
            placeholder="Логин"
            autocomplete="username"
            required
          />
          <input
            v-model="creds.password"
            class="a-input"
            type="password"
            placeholder="Пароль"
            autocomplete="current-password"
            required
          />
          <button class="a-btn a-btn-primary" type="submit" :disabled="busy">
            {{ busy ? 'Входим...' : 'Войти' }}
          </button>
          <p v-if="loginErr" class="a-err">{{ loginErr }}</p>
        </form>
      </div>
    </div>

    <!-- ── ДАШБОРД ────────────────────────────────────────────── -->
    <div v-else class="a-dash">

      <!-- СПИСОК -->
      <div v-if="view === 'list'" class="a-panel">
        <div class="a-topbar">
          <span class="a-topbar-title">
            Статьи
            <span class="a-count">{{ articles.length }}</span>
          </span>
          <div class="a-topbar-actions">
            <button class="a-btn a-btn-primary" @click="startCreate">+ Создать</button>
            <button class="a-btn a-btn-ghost" @click="doLogout">Выйти</button>
          </div>
        </div>

        <input
          v-model="search"
          class="a-input a-search"
          placeholder="Поиск по slug или заголовку..."
        />

        <div class="a-table-wrap">
          <table class="a-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Slug</th>
                <th>Заголовок</th>
                <th>Дата</th>
                <th>Статус</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="a in filtered"
                :key="a.id"
                :class="{ 'a-row-off': !a.is_active }"
              >
                <td class="a-td-id">{{ a.id }}</td>
                <td class="a-td-slug">{{ a.slug }}</td>
                <td class="a-td-title">{{ a.title }}</td>
                <td class="a-td-date">{{ a.date }}</td>
                <td>
                  <span :class="a.is_active ? 'a-badge-on' : 'a-badge-off'">
                    {{ a.is_active ? 'Активна' : 'Скрыта' }}
                  </span>
                </td>
                <td class="a-td-actions">
                  <button class="a-btn a-btn-sm" @click="startEdit(a)">
                    Редактировать
                  </button>
                  <button
                    class="a-btn a-btn-sm"
                    :class="a.is_active ? 'a-btn-warn' : 'a-btn-ok'"
                    @click="toggleArticle(a)"
                  >
                    {{ a.is_active ? 'Скрыть' : 'Включить' }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- РЕДАКТОР -->
      <div v-else class="a-panel">
        <div class="a-topbar">
          <span class="a-topbar-title">
            {{ view === 'create' ? 'Новая статья' : 'Редактирование' }}
          </span>
          <button class="a-btn a-btn-ghost" @click="view = 'list'">← Назад</button>
        </div>

        <form class="a-form" @submit.prevent="saveArticle">

          <div class="a-form-row-2">
            <div class="a-field">
              <label>Slug *</label>
              <input
                v-model="form.slug"
                class="a-input"
                :readonly="view === 'edit'"
                required
                placeholder="My_Article_Slug"
              />
              <span v-if="view === 'edit'" class="a-hint">Slug нельзя менять</span>
            </div>
            <div class="a-field">
              <label>Дата публикации</label>
              <input v-model="form.date" class="a-input" placeholder="13 октября 2025" />
            </div>
          </div>

          <div class="a-field">
            <label>Заголовок *</label>
            <input v-model="form.title" class="a-input" required />
          </div>

          <div class="a-field">
            <label>SEO Title</label>
            <input v-model="form.seo_title" class="a-input" />
          </div>

          <div class="a-field">
            <label>SEO Description</label>
            <textarea v-model="form.seo_description" class="a-input a-textarea" rows="3"></textarea>
          </div>

          <div class="a-form-row-3">
            <div class="a-field">
              <label>Изображение (filename)</label>
              <input v-model="form.image" class="a-input" placeholder="article_name.webp" />
            </div>
            <div class="a-field">
              <label>Автор — имя</label>
              <input v-model="form.author_name" class="a-input" />
            </div>
            <div class="a-field">
              <label>Автор — должность</label>
              <input v-model="form.author_position" class="a-input" />
            </div>
          </div>

          <div class="a-field">
            <label>HTML контент</label>
            <textarea v-model="form.html_content" class="a-input a-textarea a-html-area" rows="28"></textarea>
          </div>

          <div class="a-form-footer">
            <label class="a-checkbox-label">
              <input type="checkbox" v-model="form.is_active" />
              Активна (видна на сайте)
            </label>
            <div class="a-form-actions">
              <span v-if="saveOk" class="a-ok">✓ Сохранено</span>
              <span v-if="saveErr" class="a-err">{{ saveErr }}</span>
              <button class="a-btn a-btn-primary" type="submit" :disabled="busy">
                {{ busy ? 'Сохранение...' : 'Сохранить' }}
              </button>
            </div>
          </div>

        </form>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';

const EMPTY_FORM = () => ({
  id: null,
  slug: '',
  title: '',
  seo_title: '',
  seo_description: '',
  date: '',
  image: '',
  html_content: '',
  author_name: '',
  author_position: '',
  author_image: 'kirill.png',
  is_active: true,
});

export default {
  name: 'AdminPage',
  setup() {
    const authed    = ref(false);
    const view      = ref('list');   // 'list' | 'edit' | 'create'
    const busy      = ref(false);
    const loginErr  = ref('');
    const saveErr   = ref('');
    const saveOk    = ref(false);
    const articles  = ref([]);
    const search    = ref('');
    const creds     = ref({ login: '', password: '' });
    const form      = ref(EMPTY_FORM());

    const filtered = computed(() => {
      const q = search.value.toLowerCase();
      if (!q) return articles.value;
      return articles.value.filter(
        (a) => a.slug.toLowerCase().includes(q) || a.title.toLowerCase().includes(q)
      );
    });

    // ── auth ────────────────────────────────────────────────────

    async function checkAuth() {
      try {
        const res = await fetch('/admin/check', { credentials: 'include' });
        authed.value = res.ok;
        if (authed.value) loadArticles();
      } catch { authed.value = false; }
    }

    async function doLogin() {
      busy.value = true;
      loginErr.value = '';
      try {
        const res = await fetch('/admin/login', {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(creds.value),
        });
        const data = await res.json();
        if (!res.ok) { loginErr.value = data.error || 'Ошибка'; return; }
        authed.value = true;
        creds.value = { login: '', password: '' };
        loadArticles();
      } catch { loginErr.value = 'Ошибка соединения'; }
      finally { busy.value = false; }
    }

    async function doLogout() {
      await fetch('/admin/logout', { method: 'POST', credentials: 'include' });
      authed.value = false;
      view.value = 'list';
      articles.value = [];
    }

    // ── articles ─────────────────────────────────────────────────

    async function loadArticles() {
      try {
        const res = await fetch('/admin/articles', { credentials: 'include' });
        articles.value = await res.json();
      } catch (e) { console.error('loadArticles:', e); }
    }

    function startCreate() {
      form.value = EMPTY_FORM();
      saveOk.value = false;
      saveErr.value = '';
      view.value = 'create';
    }

    function startEdit(article) {
      form.value = { ...EMPTY_FORM(), ...article };
      saveOk.value = false;
      saveErr.value = '';
      view.value = 'edit';
    }

    async function saveArticle() {
      busy.value = true;
      saveOk.value = false;
      saveErr.value = '';
      try {
        const isEdit = view.value === 'edit';
        const url  = isEdit ? `/admin/articles/${form.value.id}` : '/admin/articles';
        const method = isEdit ? 'PUT' : 'POST';
        const res = await fetch(url, {
          method,
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(form.value),
        });
        const data = await res.json();
        if (!res.ok) { saveErr.value = data.error || 'Ошибка сохранения'; return; }
        saveOk.value = true;
        await loadArticles();
        if (!isEdit) {
          form.value.id = data.id;
          view.value = 'edit';
        }
        setTimeout(() => { saveOk.value = false; }, 3000);
      } catch { saveErr.value = 'Ошибка соединения'; }
      finally { busy.value = false; }
    }

    async function toggleArticle(article) {
      try {
        const res = await fetch(`/admin/articles/${article.id}/toggle`, {
          method: 'PATCH',
          credentials: 'include',
        });
        if (!res.ok) return;
        const updated = await res.json();
        const idx = articles.value.findIndex((a) => a.id === article.id);
        if (idx !== -1) articles.value[idx] = { ...articles.value[idx], ...updated };
      } catch (e) { console.error('toggle:', e); }
    }

    onMounted(checkAuth);

    return {
      authed, view, busy, loginErr, saveErr, saveOk,
      articles, filtered, search, creds, form,
      doLogin, doLogout, startCreate, startEdit, saveArticle, toggleArticle,
    };
  },
};
</script>

<style scoped>
/* ── reset & base ──────────────────────────────────────────── */
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

.a-wrap {
  min-height: 100vh;
  background: #0d0d0d;
  color: #e8e8e8;
  font-family: 'Raleway', sans-serif;
  font-size: 0.9rem;
}

/* ── login ─────────────────────────────────────────────────── */
.a-login {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}
.a-login-box {
  background: #181818;
  border: 1px solid #2a2a2a;
  border-radius: 12px;
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.a-logo {
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #7b8aff;
  text-align: center;
}
.a-login-box form { display: flex; flex-direction: column; gap: 0.8rem; }

/* ── dashboard ─────────────────────────────────────────────── */
.a-dash { display: flex; flex-direction: column; min-height: 100vh; }

.a-panel {
  flex: 1;
  padding: 1.5rem 2rem;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
}

/* ── topbar ────────────────────────────────────────────────── */
.a-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #222;
}
.a-topbar-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.a-count {
  background: #2a2a3a;
  color: #7b8aff;
  border-radius: 20px;
  padding: 0.1rem 0.6rem;
  font-size: 0.8rem;
  font-weight: 700;
}
.a-topbar-actions { display: flex; gap: 0.6rem; }

/* ── search ────────────────────────────────────────────────── */
.a-search { margin-bottom: 1rem; width: 100%; max-width: 420px; }

/* ── table ─────────────────────────────────────────────────── */
.a-table-wrap { overflow-x: auto; }
.a-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}
.a-table th {
  text-align: left;
  padding: 0.6rem 0.8rem;
  color: #888;
  font-weight: 600;
  border-bottom: 1px solid #222;
  white-space: nowrap;
}
.a-table td {
  padding: 0.6rem 0.8rem;
  border-bottom: 1px solid #1a1a1a;
  vertical-align: middle;
}
.a-table tbody tr:hover { background: #141414; }
.a-row-off { opacity: 0.45; }

.a-td-id   { color: #555; width: 50px; }
.a-td-slug { color: #7b8aff; font-size: 0.78rem; max-width: 220px; word-break: break-all; }
.a-td-title { max-width: 340px; }
.a-td-date  { color: #888; white-space: nowrap; }
.a-td-actions { display: flex; gap: 0.4rem; align-items: center; white-space: nowrap; }

/* ── badges ────────────────────────────────────────────────── */
.a-badge-on  { background:#1a3a1a; color:#5dba5d; border-radius:4px; padding:0.15rem 0.5rem; font-size:0.75rem; }
.a-badge-off { background:#3a1a1a; color:#bb5555; border-radius:4px; padding:0.15rem 0.5rem; font-size:0.75rem; }

/* ── buttons ───────────────────────────────────────────────── */
.a-btn {
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.5rem 1rem;
  transition: opacity 0.15s;
}
.a-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.a-btn:not(:disabled):hover { opacity: 0.85; }

.a-btn-primary { background: #5b6cff; color: #fff; }
.a-btn-ghost   { background: #222; color: #ccc; border: 1px solid #333; }
.a-btn-ok      { background: #1a3a1a; color: #5dba5d; }
.a-btn-warn    { background: #3a1a1a; color: #bb5555; }
.a-btn-sm      { padding: 0.3rem 0.7rem; font-size: 0.78rem; }

/* ── form ──────────────────────────────────────────────────── */
.a-form { display: flex; flex-direction: column; gap: 1rem; }

.a-form-row-2 { display: grid; grid-template-columns: 2fr 1fr; gap: 1rem; }
.a-form-row-3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 1rem; }

.a-field { display: flex; flex-direction: column; gap: 0.35rem; }
.a-field label { font-size: 0.78rem; color: #888; font-weight: 600; letter-spacing: 0.03em; }

.a-hint { font-size: 0.72rem; color: #555; }

.a-input {
  background: #181818;
  border: 1px solid #2a2a2a;
  border-radius: 6px;
  color: #e8e8e8;
  font-family: inherit;
  font-size: 0.88rem;
  outline: none;
  padding: 0.55rem 0.75rem;
  transition: border-color 0.15s;
  width: 100%;
}
.a-input:focus { border-color: #5b6cff; }
.a-input[readonly] { color: #555; cursor: not-allowed; }
.a-textarea { resize: vertical; line-height: 1.5; }
.a-html-area { font-family: 'Courier New', monospace; font-size: 0.8rem; }

/* ── form footer ───────────────────────────────────────────── */
.a-form-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.5rem;
  border-top: 1px solid #222;
  flex-wrap: wrap;
  gap: 0.8rem;
}
.a-form-actions { display: flex; align-items: center; gap: 1rem; }
.a-checkbox-label { display: flex; align-items: center; gap: 0.5rem; cursor: pointer; font-size: 0.88rem; }
.a-checkbox-label input[type="checkbox"] { accent-color: #5b6cff; width: 16px; height: 16px; }

/* ── status ────────────────────────────────────────────────── */
.a-err { color: #e05555; font-size: 0.83rem; }
.a-ok  { color: #5dba5d; font-size: 0.83rem; }

/* ── responsive ────────────────────────────────────────────── */
@media (max-width: 768px) {
  .a-panel { padding: 1rem; }
  .a-form-row-2, .a-form-row-3 { grid-template-columns: 1fr; }
  .a-topbar { flex-direction: column; align-items: flex-start; gap: 0.8rem; }
}
</style>
